module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corporatecommunity"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "smallimgholder"
  }, [_c('br'), _vm._v(" "), (_vm.siblingCorps && _vm.user.isSuperUser) ? _c('button', {
    staticClass: "btn formButton btn-block smallimgholder",
    style: ({
      color: _vm.$a11yTextColor(_vm.getCorpButtonColor) + ' !important',
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSwitchModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.getParentCorporation.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.smallImage,
      "alt": "CORP IMAGE",
      "title": _vm.user.corporation.name
    }
  }), _c('div', {
    staticClass: "hidemobile"
  }, [_c('br'), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.user.corporation.pageWelcomeMessage))]), _vm._v(" "), _c('div', {
    class: {
      hidden: _vm.isHidden()
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/toneApp.png"),
      "alt": "APP QR CODE",
      "text": "APP QR Code"
    }
  }), _c('br'), _vm._v(" " + _vm._s(_vm.user.corporation.pageWelcomeMessage) + "Scan the QR code to download our app and enjoy Tone on the go!\n                        "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 margin-bottom-40"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [(_vm.user.corporation.showSpotlightSection || _vm.user.corporation.showPinnedMessages) ? _c('li', {
    staticClass: "community",
    class: {
      current: _vm.selectedTab === 'community'
    },
    style: ([_vm.selectedTab === 'community' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('community')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([_vm.selectedTab === 'community' ? {
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'color': '#333'
    }]),
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'community') ? 'true' : 'false'
    }
  }, [_vm._v("Community")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'events'
    },
    style: ([_vm.selectedTab === 'events' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('events')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([_vm.selectedTab === 'events' ? {
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'color': '#333'
    }]),
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'events') ? 'true' : 'false'
    }
  }, [_c('span', {
    staticClass: "hidemobile"
  }, [_vm._v("Coaching")]), _vm._v(" Events")])]), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('li', {
    staticClass: "events",
    class: {
      current: _vm.selectedTab === 'videos'
    },
    style: ([_vm.selectedTab === 'videos' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('videos')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([_vm.selectedTab === 'videos' ? {
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'color': '#333'
    }]),
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'videos') ? 'true' : 'false'
    }
  }, [_vm._v(" Videos")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPlaylists && _vm.user.corporation.corporationId !== 200) ? _c('li', {
    staticClass: "playlists",
    class: {
      current: _vm.selectedTab === 'playlists'
    },
    style: ([_vm.selectedTab === 'playlists' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('playlists')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([_vm.selectedTab === 'playlists' ? {
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'color': '#333'
    }]),
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'playlists') ? 'true' : 'false'
    }
  }, [_vm._v("Playlists")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPlaylists && _vm.user.corporation.corporationId === 200) ? _c('li', {
    staticClass: "playlists",
    class: {
      current: _vm.selectedTab === 'playlists'
    },
    style: ([_vm.selectedTab === 'playlists' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('manplaylists')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([_vm.selectedTab === 'manplaylists' ? {
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'color': '#333'
    }]),
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'playlists') ? 'true' : 'false'
    }
  }, [_vm._v("Manager Playlists")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPlaylists && _vm.user.corporation.corporationId === 200) ? _c('li', {
    staticClass: "playlists",
    class: {
      current: _vm.selectedTab === 'playlists'
    },
    style: ([_vm.selectedTab === 'playlists' ? {
      'borderBottom': '1px solid ' + _vm.getCorpHeaderColor + ' !important'
    } : {
      'borderBottom': '1px solid #333 !important'
    }]),
    on: {
      "click": function($event) {
        return _vm.switchTab('dirplaylists')
      }
    }
  }, [_c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    style: ([_vm.selectedTab === 'dirplaylists' ? {
      'color': _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    } : {
      'color': '#333'
    }]),
    attrs: {
      "aria-pressed": (_vm.selectedTab === 'playlists') ? 'true' : 'false'
    }
  }, [_vm._v("Director Playlists")])]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTab === 'community') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.community
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [(_vm.user.corporation.showSpotlightSection) ? _c('div', {
    staticClass: "row video-row introparacard"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.user.corporation.spotlightPic) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.corporation.spotlightPic,
      "alt": "SPOTLIGHT IMAGE",
      "title": "In Spotlight"
    }
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.user.corporation.spotlightPara1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.corporation.spotlightPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.corporation.spotlightPara2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.corporation.spotlightPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.corporation.spotlightPara3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.user.corporation.spotlightPara3)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.user.corporation.spotlightQuote) ? _c('blockquote', [_vm._v("\"" + _vm._s(_vm.user.corporation.spotlightQuote) + "\"")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr', {
    staticClass: "redhr",
    style: ({
      'border-color': this.getCorpHeaderColor + ' !important'
    })
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCorporationPinnedMsgs && (_vm.user.corporation.showPinnedMessages || _vm.user.corporation.showPinnedMessages === 1)) ? _c('div', {
    staticClass: "pinnedmsgs"
  }, [(_vm.user.corporation.pinnedMessageHeading) ? _c('h3', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.user.corporation.pinnedMessageHeading) + " "), _c('i', {
    staticClass: "fa fa-map-pin ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.getCorporationPinnedMsgs), function(msg) {
    return _c('div', {
      staticClass: "borderedbox"
    }, [_c('h4', [_vm._v(_vm._s(msg.msgSenderName) + " "), _c('small', [_vm._v(_vm._s(msg.msgSentDateFmt))])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(msg.corpAdminMessage)
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'events') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.events
    },
    attrs: {
      "id": "tabs-2"
    }
  }, [(_vm.getCorpMainEvent) ? _c('div', {
    staticClass: "row video-row"
  }, [(_vm.getCorpMainEvent.isPrivate === 1) ? _c('h3', [_c('b', [_vm._v("Join " + _vm._s(_vm.user.corporation.name) + " and TONE Networks for this EXCLUSIVE coaching event on " + _vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))])]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.isPrivate !== 1) ? _c('h3', [_c('b', [_vm._v("Join our monthly livestream events for interactive coaching that is designed for your personal and professional needs. Get your questions ready!")])]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent && _vm.getCorpMainEvent.type !== '3' && _vm.showJoin(_vm.getCorpMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getCorpMainEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.getCorpMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive"
  }, [_c('img', {
    attrs: {
      "src": _vm.getCorpMainEvent.img_url,
      "alt": "CORP MAIN EVENT BANENR",
      "title": _vm.getCorpMainEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-left large-text"
  }, [_c('h3', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpMainEvent.longDescription))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpMainEvent.start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpMainEvent.eventId)) ? _c('div', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpMainEvent.title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpMainEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpMainEvent.isPrivate === 1) ? _c('span', [(_vm.getCorpMainEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()]) : _c('span', [(_vm.getCorpMainEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.getCorpMainEvent.eventId)))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '2') ? _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.getCorpMainEvent.eventId)))]) : _vm._e(), _vm._v(" "), (_vm.getCorpMainEvent.type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpMainEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.getCorpMainEvent && _vm.getCorpMainEvent.type !== '3' && !_vm.showJoin(_vm.getCorpMainEvent.eventId)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.getCorpMainEvent) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.getCorpMainEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length >= 2) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.user.corporation.privateEventHeading) ? _c('h3', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.user.corporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpPrivateEvents[0].title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpPrivateEvents[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[1].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[1].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[1].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[1].eventId)) ? _c('div', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpPrivateEvents[1].title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[1].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[1].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[1].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[1].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpPrivateEvents[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share\n                                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents && _vm.getCorpPrivateEvents.length === 1) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_c('b', [(_vm.user.corporation.privateEventHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.user.corporation.privateEventHeading))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 m-auto imgresponsive large-text text-left"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getCorpPrivateEvents[0].img_url,
      "alt": "PRIVATE EVENT BANNER",
      "title": _vm.getCorpPrivateEvents[0].title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDateReference(_vm.getCorpPrivateEvents[0].start_date, 'str')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.getCorpPrivateEvents[0].eventId)) ? _c('div', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.getCorpPrivateEvents[0].title)
      }
    }
  }, [_vm._v("\n                                        Add to Calendar\n                                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getCorpPrivateEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.getCorpPrivateEvents[0].type === '1') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '2') ? _c('span', [_vm._v(_vm._s(_vm.privateEventURL))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateEvents[0].type === '3') ? _c('span', [_vm._v(_vm._s(_vm.user.corporation.name) + "'s Self-Hosted Event")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.getCorpPrivateEvents[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share\n                                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    }
  }), _vm._v(" "), (_vm.getCorpPublicEvents) ? _c('div', {
    staticClass: "sliderEventBox"
  }, [(_vm.user.corporation.toneEventHeading) ? _c('h2', [_vm._v(_vm._s(_vm.user.corporation.toneEventHeading))]) : _vm._e(), _vm._v(" "), (_vm.getCorpPublicEvents) ? _c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.carouselSettings, false), _vm._l((_vm.getCorpPublicEvents), function(ev) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('h2', {
      staticClass: "carosalh2",
      style: ({
        color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
      })
    }, [(ev.type === '1') ? _c('span', [_vm._v(" TONE Live\n")]) : _c('span', [_vm._v(_vm._s(ev.title) + " ")])]), _vm._v(" "), _c('img', {
      staticClass: "sliderimage",
      attrs: {
        "src": ev.img_url,
        "alt": "PUBLIC EVENT BANNER",
        "title": ev.title
      }
    }), _vm._v(" "), _c('h2', [_c('a', {
      style: ({
        color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
      }),
      attrs: {
        "href": '/event/' + ev.eventId,
        "target": "new"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(ev.start_date, 'live')) + " with " + _vm._s(_vm.replaceLastExpert(ev.csvExpertsNames, ',', ' & ')))])]), _vm._v(" "), _c('p', [_vm._v("\n                                            " + _vm._s(ev.longDescription) + "\n                                        ")]), _vm._v(" "), _c('h5', [_vm._v("LIVE " + _vm._s(_vm.getDateReference(ev.start_date, 'live2')))]), _vm._v(" "), (!_vm.showJoin(ev.eventId)) ? _c('div', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "addeventatc pinkoutlinebtn",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        border: '1px solid ' + _vm.getCorpButtonColor
      }),
      attrs: {
        "title": "Add to Calendar"
      },
      on: {
        "click": function($event) {
          return _vm.calendarLogging($event, ev.title)
        }
      }
    }, [_vm._v("\n                                            Add to Calendar\n                                            "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(ev.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(ev.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("ev/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(ev.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(ev.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.buildEventLink(ev.eventId)))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
      staticClass: "share-event",
      style: ({
        color: _vm.$a11yInkColor(_vm.getCorpButtonColor) + ' !important',
        borderWidth: '1px !important',
        borderStyle: 'solid !important',
        borderColor: _vm.getCorpButtonColor + ' !important'
      }),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateImageShareModal(ev)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-share-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Share\n                                        ")]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "3px solid #cbcbcb",
      "margin-bottom": "30px"
    },
    attrs: {
      "id": "missed"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.user.corporation.archiveEventHeading) ? _c('h3', [_c('strong', [_vm._v(_vm._s(_vm.user.corporation.archiveEventHeading))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.getCorpArchiveEvents) ? _c('div', {
    staticClass: "sliderEventBox pointer"
  }, [(_vm.getCorpArchiveEvents) ? _c('VueSlickCarousel', _vm._b({}, 'VueSlickCarousel', _vm.carouselSettings, false), _vm._l((_vm.getCorpArchiveEvents), function(evn) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "show-share-options",
      style: ({
        backgroundColor: _vm.getCorpHeadingColor,
        'cursor': 'pointer'
      })
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "sliderimage",
      attrs: {
        "aria-label": evn.title,
        "src": evn.img_url,
        "alt": "PRIVATE EVENT BANNER",
        "title": evn.title
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), _c('div', {
      staticClass: "favnumbers-a",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(evn.allVidDurInMinutes)), _c('small', [_vm._v("mins")])])]), _c('i', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-label": "Play",
        "title": "Play"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }), (((_vm.user && _vm.user.corporation === null) || (_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission >= 1))) ? _c('i', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "fa fa-share-square-o",
      attrs: {
        "aria-label": "Share Playlist",
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          _vm.openCorporateShareModal('event', evn)()
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('h2', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v(_vm._s(evn.title))])]), _vm._v(" "), _c('p', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      on: {
        "click": function($event) {
          return _vm.playVideoArchive(evn.eventId, evn.title)
        }
      }
    }, [_vm._v("\n                                                " + _vm._s(evn.longDescription) + "\n\n                                            ")])])
  }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px",
      "border-bottom": "1px solid #ddd"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'videos') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.videos
    },
    attrs: {
      "id": "tabs-3"
    }
  }, [(_vm.user.corporation.videoTabHeading) ? _c('h3', [_c('b', [_vm._v(_vm._s(_vm.user.corporation.videoTabHeading))])]) : _vm._e(), _vm._v(" "), (_vm.getCorpPrivateVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, _vm._l((_vm.getCorpPrivateVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "alt": video.title,
        "title": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                                                 " + _vm._s(video.title) + "\n                                             ")])])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'playlists' || _vm.selectedTab === 'manplaylists' || _vm.selectedTab === 'dirplaylists') ? _c('div', {
    staticClass: "tabContent",
    class: {
      current: _vm.tabs.playlists
    },
    attrs: {
      "id": "tabs-4"
    }
  }, [(_vm.getCorpPlaylists) ? _c('div', {
    staticClass: "row video-row plistisrow"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.user.corporation.playlistHeading && _vm.selectedTab === 'manplaylists') ? _c('h2', [_vm._v("Horizon's Manager Playlists")]) : _vm._e(), _vm._v(" "), (_vm.user.corporation.playlistHeading && _vm.selectedTab === 'dirplaylists') ? _c('h2', [_vm._v("Horizon's Director Playlists")]) : _vm._e(), _vm._v(" "), (_vm.user.corporation.playlistHeading && _vm.selectedTab === 'playlists') ? _c('h2', [_vm._v(_vm._s(_vm.user.corporation.playlistHeading))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  })]), _vm._v(" "), _vm._l((_vm.getCorpPlaylists), function(playlist) {
    return (playlist.userPlaylistVideos && ((_vm.selectedTab === 'playlists' && playlist.playlistCategory === 0) || (_vm.selectedTab === 'manplaylists' && (playlist.playlistCategory === 1 || playlist.playlistCategory === 99)) || (_vm.selectedTab === 'dirplaylists' && (playlist.playlistCategory === 2 || playlist.playlistCategory === 99)))) ? _c('div', [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 "
    }, [(playlist.userPlaylistVideos && playlist.userPlaylistVideos.length > 0) ? _c('div', {
      staticClass: "pinkbg",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-label": playlist.title,
        "src": playlist.userPlaylistVideos[0].thumbnailURL,
        "alt": playlist.title,
        "title": playlist.title
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pinksidebarmin",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('span', {
      staticClass: "numb"
    }, [_c('strong', [_vm._v(_vm._s(playlist.userPlaylistVideos.length))])]), _vm._v(" "), _c('i', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-label": "Play video"
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1)) ? _c('i', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "fa fa-share-square-o",
      attrs: {
        "aria-label": "Share Playlist",
        "title": "Share Playlist"
      },
      on: {
        "click": function($event) {
          return _vm.openCorporateShareModal('playlist', playlist)
        }
      }
    }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 pltext"
    }, [_c('h3', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)
        }
      }
    }, [_vm._v(_vm._s(playlist.title))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(playlist.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix",
      staticStyle: {
        "height": "10px"
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.getCropUserSharedVideos) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Here are all videos shared with you by your colleagues")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "50px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row  video-row plistisrow flexwrap"
  }, _vm._l((_vm.getCropUserSharedVideos), function(video) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [(video.playlistId === 0) ? _c('div', {
      staticClass: "videoholdersuggestions"
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      attrs: {
        "aria-label": video.videoTitle,
        "src": video.thumbnailURL,
        "alt": video.videoTitle,
        "title": video.videoTitle
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode, video.videoTitle)
        }
      }
    }), _vm._v(" "), _c('h3', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoPlayerObject(video.videoCode, video.videoTitle)
        }
      }
    }, [_vm._v(_vm._s(video.videoTitle))])]), _vm._v(" "), _c('p', [_vm._v("Shared by " + _vm._s(video.senderName))]), _vm._v(" "), _c('p', [_vm._v("Message: " + _vm._s(video.messageText))])]) : _vm._e(), _vm._v(" "), (video.playlistId > 0) ? _c('div', {
      staticClass: "videoholdersuggestions "
    }, [_c('div', {
      staticClass: "viderowraper-shared",
      class: {
        'innerimggray': _vm.getTrialDays < 0
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylistForShared(video)
        }
      }
    }, [_c('div', {
      staticClass: "favnumbers",
      style: ({
        backgroundColor: _vm.getCorpHeaderColor
      })
    }, [_c('div', [_c('span', [_vm._v(_vm._s(video.playlistDuration))]), _c('small', [_vm._v("mins")])]), _c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true",
        "title": "Play"
      }
    })]), _vm._v(" "), _c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      attrs: {
        "aria-label": video.playlistTitle,
        "src": video.thumbnailURL,
        "alt": video.playlistTitle,
        "title": video.playlistTitle
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylistForShared(video)
        }
      }
    })]), _vm._v(" "), _c('h3', [_c('button', {
      staticClass: "tone-heading-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.playPlaylistForShared(video)
        }
      }
    }, [_vm._v(_vm._s(video.playlistTitle))])]), _vm._v(" "), _c('p', [_vm._v("Shared by " + _vm._s(video.senderName))]), _vm._v(" "), _c('p', [_vm._v("Message: " + _vm._s(video.messageText))])]) : _vm._e()])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    attrs: {
      "aria-label": "Share with"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "aria-label": "Corporate recipients",
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "aria-label": "Email recipients",
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "aria-label": "Type your message",
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess)) || (_vm.shareInProcess)
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateSwitch) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateSwitch
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateSwitchModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Switch to a different corporation\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateSwitchModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.getParentCorporation.name))]), _vm._v(" "), (_vm.getParentCorporation.description) ? _c('h5', [_vm._v(_vm._s(_vm.getParentCorporation.description))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 fourinarow"
  }, _vm._l((_vm.siblingCorps), function(corp) {
    return (_vm.siblingCorps) ? _c('div', {
      staticClass: "radio"
    }, [_c('label', {
      class: {
        active: _vm.selectedCorpId === corp.corporationId
      }
    }, [_c('span', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(corp.name))]), _vm._v(" "), _c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('img', {
      staticClass: "thumbnail embed-responsive-item",
      attrs: {
        "src": corp.smallImage ? corp.smallImage : 'https://s3.amazonaws.com/tone-assets/images/corporate/crystal.png',
        "alt": "CORP IMAGE",
        "title": corp.name
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCorpId),
        expression: "selectedCorpId"
      }],
      attrs: {
        "type": "radio",
        "id": corp.corporationId,
        "name": "corpSwitch"
      },
      domProps: {
        "value": corp.corporationId,
        "checked": _vm._q(_vm.selectedCorpId, corp.corporationId)
      },
      on: {
        "change": function($event) {
          _vm.selectedCorpId = corp.corporationId
        }
      }
    })])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateSwitchModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": _vm.shareInProcess || (_vm.selectedCorpId === _vm.user.corporation.corporationId)
    },
    on: {
      "click": function($event) {
        return _vm.switchCorporation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Switch\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    attrs: {
      "aria-label": "Share with"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), (_vm.shareEventSelected.isPrivate.toString() !== '1') ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "aria-label": "Corporate recipients",
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "aria-label": "Email recipients",
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "aria-label": "Type your message",
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      color: _vm.$a11yTextColor(_vm.getCorpButtonColor) + ' !important',
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e(), _vm._v(" "), (_vm.showCorporateShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    directives: [{
      name: "a11y-action",
      rawName: "v-a11y-action"
    }],
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    attrs: {
      "aria-label": "Share with"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.showShareCommunity) ? _c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]) : _vm._e(), _vm._v(" "), (_vm.showShareIndividual) ? _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.showShareFriends) ? _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")]) : _vm._e()])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "aria-label": "Corporate recipients",
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "aria-label": "Email recipients",
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "aria-label": "Type your message",
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.corpShareModalImage,
      "alt": _vm.corpShareModalTitle,
      "title": _vm.corpShareModalTitle
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s((_vm.corpShareModalTitle + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.corpShareModalDesc.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor,
      border: '1px solid' + _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateVideo()
      }
    }
  }, [_vm._v("\n                            Share This Playlist\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ff1e25a", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ff1e25a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/CorporateCommunity.vue